import './table-scroll'
import StatisticsIndicatorMeta from './statistics-metabox'
import { StatisticsSearch,
    TableTreeToggle,
    StatisticsSorting,
    StatisticsPreloader,
    StatisticsTableSettings,
    StatisticsTableAnchors,
    StatisticsTableMarking
}
    from './statistics-table'
import StatisticsChart from "./statistics-chart";
import StatisticsMap from "./statistics-map";
import StatisticsView from "./statistics-views";


//import StatisticsIndicatorMeta from "./statistics-metabox";
//import StatisticsChart from "./statistics-chart";

function init_stats_tables(){
    var $topHeader =  $(".top-header .navbar");
    if($(".statistics-tbl-c.render-table").length == 0) return;

    var $topHeader =  $(".top-header .navbar");
    if($(".statistics-tbl-c.render-table").length == 0) return;

    $(".statistics-tbl-c.render-table").each(function(){
        var $this = $(this);
        if($this.data('inited')) return;

        var $table = $(this).find(".main-table");

        var tableScroll = $table.evinTableScroll({
            topScrollTopOffset: function () {
                return $topHeader.innerHeight();
            },
            removeClasses: "main-table",
            scrollableWrap: $table.parents(".tables-wrap")
        });

        new StatisticsIndicatorMeta($this);
        new StatisticsSearch($this, tableScroll);
        new TableTreeToggle($this, tableScroll);
        new StatisticsSorting($this, tableScroll);
        new StatisticsPreloader($this, tableScroll);
        new StatisticsTableSettings($this, tableScroll);
        new StatisticsTableAnchors($this, tableScroll);
        new StatisticsTableMarking($this, $table);
        if($this.find('.render-chart').length){
            new StatisticsChart($this, $this.find(".filter_form"))
        }

        $this.find(".filter_form").submit(function () {
            $(this).find("input,select").each(function () {
                if ($(this).val() == '') {
                    $(this).attr("name", "");
                }
            })
            $(this).fadeTo(300, 0.5);
        });

        var filterTimeoutId = null;

        $this.find(".filter_form select, .filter_form input:not([name='query'])").on("change", function(){

            clearTimeout(filterTimeoutId)
            filterTimeoutId = setTimeout(function (){
                $(".filter_form").submit();
            }, 1000);
        });

        //Jei paspaudžiamas tab'as, kuris turi hash'ą (o ne nuorodą) - uždedam hash'ą į nuorodą
        $this.find('.nav-tabs a.nav-link[href^="#"]').click(function(event) {
            //window.location.hash = $(this).attr('href');
            history.replaceState({}, "", $(this).attr('href'))
        });

        setTimeout(function (){
            if(window.location.hash){
                bootstrap.Tab.getOrCreateInstance(
                    $this.find(".nav-table-tabs a.nav-link[href='"+window.location.hash+"']")[0]
                ).show()
            }else{
                bootstrap.Tab.getOrCreateInstance(
                    $this.find(".nav-table-tabs a.nav-link")[0]
                ).show()
            }
        }, 100)


        $this.data('inited', true);
    });
}

function init_widget_tables(){
    $('[data-statistics-table-widget]').each(function () {
        let statisticsChart = new StatisticsChart($(this), {})
        statisticsChart.reloadChartData()
    })
}


init_stats_tables();
init_widget_tables();
